import { IGame } from 'interfaces/api/IGame';
import { makeAutoObservable } from 'mobx';
import { IGamesService } from 'services/data-services/GamesService';

class GameStore {
  gameService: IGamesService;

  game: IGame | undefined = undefined;

  hidePitchLocation = false;

  constructor(gameService: IGamesService) {
    this.gameService = gameService;
    makeAutoObservable(this);
  }

  setGameById = async (id: string, isScheduledGame: boolean, useSharingNetworkRules: boolean) => {
    const result = await this.gameService.getGame(id, isScheduledGame, useSharingNetworkRules);
    this.game = result;
  };

  setGameManually = (game: IGame) => {
    this.game = game;
  };

  getLeagueById = async () => {
    if (this.game) {
      this.game.league = await this.gameService.getLeagueById(this.game.leagueId);
    }
  };

  calculateHidePitchLocation = async () => {
    if (this.game) {
      const result = await this.gameService.calculateHidePitchLocation(
        this.game.id,
        this.game.sessionType,
        this.game.externalSessionId,
        this.game.homeTeamId,
        this.game.awayTeamId
      );
      this.hidePitchLocation = result.hidePitchLocation;
    }
  };

  clearGame = () => {
    this.game = undefined;
  };
}

export default GameStore;
